/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EvauFileUploadDates model module.
 * @module model/EvauFileUploadDates
 * @version 2.0.0
 */
class EvauFileUploadDates {
    /**
     * Constructs a new <code>EvauFileUploadDates</code>.
     * @alias module:model/EvauFileUploadDates
     */
    constructor() { 
        
        EvauFileUploadDates.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EvauFileUploadDates</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EvauFileUploadDates} obj Optional instance to populate.
     * @return {module:model/EvauFileUploadDates} The populated <code>EvauFileUploadDates</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EvauFileUploadDates();

            if (data.hasOwnProperty('lower_open')) {
                obj['lower_open'] = ApiClient.convertToType(data['lower_open'], 'Date');
            }
            if (data.hasOwnProperty('higher_close')) {
                obj['higher_close'] = ApiClient.convertToType(data['higher_close'], 'Date');
            }
        }
        return obj;
    }


}

/**
 * @member {Date} lower_open
 */
EvauFileUploadDates.prototype['lower_open'] = undefined;

/**
 * @member {Date} higher_close
 */
EvauFileUploadDates.prototype['higher_close'] = undefined;






export default EvauFileUploadDates;

